/* BG COM : pop-up d'inscription à la newsletter, 21/10/2026.
   La newsletter = tout ce qu'on envoie (offres, nouveautés, conseils de notre équipe, machines d'occasion), pas seulement l'Offre du mois.
   Rendu par snippets/bgcom-news-pop (visiteurs non connectés, hors panier, compte et pages à formulaire).
   Rien n'est chargé avant le déclencheur : ce fichier (defer, ~5 Ko) compte les pages vues et attend ; au déclenchement il charge
   le CSS et les images, puis ouvre (fixe à l'écran : aucun saut de page).
   Déclencheurs : 2e page de la visite après 6 s ; ou 1re page après 50 % de défilement et 20 s ; ou souris qui sort par le haut (bureau, après 10 s).
   Jamais : bannière cookies visible, autre fenêtre ouverte, déjà inscrit (ou venu d'un de nos e-mails), fermé depuis moins de C.days jours.
   Envoi : API client Klaviyo (clé publique du compte), liste C.list, source « Pop-up site » ; un abonné = consentement donné ici.
   24/10/2026 : offre de bienvenue BIENVENUE10 (−10 % 1re commande). Le code part par e-mail (flux Klaviyo SK9uSx), jamais affiché ici :
   une adresse fausse ne reçoit rien, la liste reste propre. Conditions affichées = réglages de la remise et de la fonction wholesale-discount. */
(function(){
  var D=document,W=window,el=D.getElementById('BgcomNewsPopData');if(!el)return;
  var C;try{C=JSON.parse(el.textContent);}catch(e){return;}
  var KEY='bgcomNews',DAY=864e5,st=load(),pv=0,t0=Date.now(),armed=false,opened=false;
  function load(){try{return JSON.parse(localStorage.getItem(KEY))||{};}catch(e){return {};}}
  function save(){try{localStorage.setItem(KEY,JSON.stringify(st));}catch(e){}}
  if(/[?&](_kx=|utm_medium=email)/.test(location.search)){st.done=Date.now();save();}
  if(!C.force&&(st.done||(st.closed&&Date.now()-st.closed<(C.days||21)*DAY)))return;
  try{pv=+sessionStorage.getItem('bgcomNewsPv')||0;sessionStorage.setItem('bgcomNewsPv',pv+1);}catch(e){}

  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return '&#'+c.charCodeAt(0)+';';});}
  function ic(d){return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+d+'</svg>';}
  var ARROW=ic('<path d="M4.5 12H18.5M13 6.5 18.5 12 13 17.5"/>');
  // pictos du jeu « Lisse » (conseil, sablage) + étiquette et étincelle dessinées sur la même grille
  var TOPICS=[
    ['Offres du mois',ic('<path d="M3.5 12.4V5.5C3.5 4.4 4.4 3.5 5.5 3.5H12.4L20.5 11.6 11.6 20.5Z"/><circle cx="8.2" cy="8.2" r="1.4"/>')],
    ['Nouveautés',ic('<path d="M12 3.5 13.8 10.2 20.5 12 13.8 13.8 12 20.5 10.2 13.8 3.5 12 10.2 10.2Z"/>')],
    ['Conseils de notre équipe',ic('<path d="M5.5 4.5H18.5C19.6 4.5 20.5 5.4 20.5 6.5V14.5C20.5 15.6 19.6 16.5 18.5 16.5H11.5L7 20V16.5H5.5C4.4 16.5 3.5 15.6 3.5 14.5V6.5C3.5 5.4 4.4 4.5 5.5 4.5Z"/><path d="M9.4 13 10.8 8.6M12.6 13 14 8.6"/>')],
    ['Machines d’occasion',ic('<path d="M12 2V3.6"/><path d="M9.6 4.8H14.4C14.9 4.8 15.2 5.2 15.2 5.7L14.2 10.4C14.1 10.8 13.8 11 13.4 11H10.6C10.2 11 9.9 10.8 9.8 10.4L8.8 5.7C8.8 5.2 9.1 4.8 9.6 4.8Z"/><path d="M12 13.6H12.1M9.9 16H10M14.1 16H14.2M7.8 18.4H7.9M12 18.4H12.1M16.2 18.4H16.3"/><path d="M3.5 21H20.5"/>')]
  ];
  function busy(){
    var b=D.getElementById('shopify-pc__banner');
    if(b&&b.offsetParent!==null&&getComputedStyle(b).visibility!=='hidden')return true;
    if(D.querySelector('dialog[open],.bgcom-pop,shopify-chat[open]'))return true;
    if([].some.call(D.querySelectorAll('[aria-modal="true"]'),function(n){return n.getClientRects().length>0;}))return true;
    return D.documentElement.classList.contains('overflow-hidden')||D.body.classList.contains('overflow-hidden');
  }
  function tryOpen(){if(opened)return;if(busy()){setTimeout(tryOpen,4000);return;}open();}

  function arm(){
    if(armed)return;armed=true;
    if(C.force){open();return;}
    if(pv>=1)setTimeout(tryOpen,6000);
    function onScroll(){
      var h=D.documentElement.scrollHeight-innerHeight;
      if(h>0&&scrollY/h>=.5){removeEventListener('scroll',onScroll);setTimeout(tryOpen,Math.max(0,20000-(Date.now()-t0)));}
    }
    addEventListener('scroll',onScroll,{passive:true});
    if(matchMedia('(hover:hover) and (pointer:fine)').matches){
      D.addEventListener('mouseout',function onOut(e){
        if(!e.relatedTarget&&e.clientY<=0&&Date.now()-t0>10000){D.removeEventListener('mouseout',onOut);tryOpen();}
      });
    }
  }

  function preload(src){return new Promise(function(r){if(!src)return r();var i=new Image();i.onload=i.onerror=function(){r();};i.src=src;});}
  function css(){
    return new Promise(function(r){
      if(D.getElementById('bgn-css'))return r();
      var l=D.createElement('link');l.id='bgn-css';l.rel='stylesheet';l.href=C.css;l.onload=l.onerror=function(){r();};D.head.appendChild(l);
    });
  }

  function open(){
    if(opened)return;opened=true;
    var I=C.img||{};
    Promise.all([css(),preload(I.hero),preload(I.pack)]).then(function(){build(I);});
  }

  function build(I){
    var prev=D.activeElement;
    var root=D.createElement('div');root.className='bgn bgn--a';
    var topics=TOPICS.map(function(t){return '<li><span class="bgn-ic">'+t[1]+'</span>'+esc(t[0])+'</li>';}).join('');
    root.innerHTML='<div class="bgn-card" role="dialog" aria-modal="true" aria-labelledby="bgn-t" aria-describedby="bgn-lead bgn-what">'
      +'<div class="bgn-art" aria-hidden="true">'
      +'<img class="bgn-pack" src="'+esc(I.pack)+'" alt="" width="'+(I.packW||1536)+'" height="'+(I.packH||1024)+'">'
      +'<img class="bgn-hero" src="'+esc(I.hero)+'" alt="" width="'+(I.heroW||720)+'" height="'+(I.heroH||494)+'">'
      +'<img class="bgn-pouce" src="'+esc(I.pouce)+'" alt="" width="360" height="346">'
      +'</div>'
      +'<div class="bgn-body">'
      +'<button type="button" class="bgn-x" aria-label="Fermer"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>'
      +'<div class="bgn-ask">'
      +'<h2 class="bgn-t" id="bgn-t"><i aria-hidden="true">//</i>Inscrivez-vous et profitez de <b>−10 % sur votre première commande.</b></h2>'
      +'<p class="bgn-p bgn-lead" id="bgn-lead">Votre code arrive par e-mail, puis tout l’atelier dans votre boîte mail :</p>'
      +'<ul class="bgn-what" id="bgn-what" aria-label="Ce que vous recevrez">'+topics+'</ul>'
      +'<form class="bgn-form" novalidate>'
      +'<label class="bgn-lab" for="bgn-e">Votre e-mail</label>'
      +'<input class="bgn-in" id="bgn-e" name="email" type="email" inputmode="email" autocomplete="email" placeholder="nom@entreprise.fr" required aria-describedby="bgn-err">'
      +'<button class="bgn-go" type="submit">Recevoir mon code'+ARROW+'</button>'
      +'<span class="bgn-hp" aria-hidden="true"><input type="text" name="website" tabindex="-1" autocomplete="off"></span>'
      +'<p class="bgn-err" id="bgn-err" role="alert"></p>'
      +'</form>'
      +'<p class="bgn-cond"><b>Conditions :</b> une fois par client, sur la première commande. Hors machines d’occasion et matériel sur devis. Non cumulable : la remise la plus avantageuse s’applique. Compte pro : vos tarifs restent appliqués.</p>'
      +'<p class="bgn-legal">En vous inscrivant, vous acceptez de recevoir les e-mails de BG COM AGENCY et Mister Paint. Désinscription en un clic dans chaque e-mail. <a href="'+esc(C.policy)+'">Politique de confidentialité</a></p>'
      +'</div>'
      +'<div class="bgn-done" tabindex="-1">'
      +'<h2 class="bgn-t">C’est noté, <b>votre code arrive.</b></h2>'
      +'<p class="bgn-p">Il part à l’instant vers <b class="bgn-em"></b>. Rien d’ici quelques minutes ? Regardez dans les courriers indésirables.</p>'
      +'<a class="bgn-ghost" href="'+esc(C.shop)+'">Voir le catalogue'+ARROW+'</a>'
      +'</div>'
      +'</div></div>';
    D.body.appendChild(root);
    var card=root.querySelector('.bgn-card'),form=root.querySelector('form'),inp=root.querySelector('#bgn-e'),err=root.querySelector('#bgn-err'),go=root.querySelector('.bgn-go');
    function close(){
      if(!root.classList.contains('is-done')){st.closed=Date.now();save();}
      D.removeEventListener('keydown',onKey);root.classList.add('out');
      setTimeout(function(){if(root.parentNode)root.parentNode.removeChild(root);},160);
      try{if(prev&&prev.focus)prev.focus({preventScroll:true});}catch(e){}
    }
    function onKey(e){
      if(e.key==='Escape'){close();return;}
      if(e.key==='Tab'){
        var f=[].filter.call(card.querySelectorAll('a[href],button,input:not([tabindex="-1"])'),function(n){return n.offsetParent!==null;});if(!f.length)return;
        var a=f[0],z=f[f.length-1];
        if(e.shiftKey&&D.activeElement===a){z.focus();e.preventDefault();}else if(!e.shiftKey&&D.activeElement===z){a.focus();e.preventDefault();}
      }
    }
    D.addEventListener('keydown',onKey);
    root.addEventListener('click',function(e){if(e.target===root)close();});
    root.querySelector('.bgn-x').addEventListener('click',close);
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var em=(inp.value||'').trim();
      if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)){inp.setAttribute('aria-invalid','true');err.textContent='Vérifiez l’adresse e-mail.';inp.focus();return;}
      inp.removeAttribute('aria-invalid');err.textContent='';
      if(form.website.value){done();return;}  // robot : on ne transmet rien
      go.disabled=true;
      fetch('https://a.klaviyo.com/client/subscriptions?company_id='+encodeURIComponent(C.company),{method:'POST',
        headers:{'Content-Type':'application/vnd.api+json',revision:'2024-10-15'},
        body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Pop-up site',
          profile:{data:{type:'profile',attributes:{email:em,properties:{bgcom_inscription_page:location.pathname}}}}},
          relationships:{list:{data:{type:'list',id:C.list}}}}})
      }).then(function(r){
        if(!r.ok)throw r.status;
        try{if(W.klaviyo&&W.klaviyo.identify)W.klaviyo.identify({email:em});}catch(x){}
        done(em);
      }).catch(function(){go.disabled=false;err.textContent='L’inscription n’est pas partie. Réessayez dans un instant.';});
    });
    function done(em){
      st.done=Date.now();save();root.querySelector('.bgn-em').textContent=em||'votre adresse';root.classList.add('is-done');
      var d=root.querySelector('.bgn-done');try{d.focus({preventScroll:true});}catch(e){}
    }
    if(!matchMedia('(prefers-reduced-motion: reduce)').matches)root.classList.add('run');
    // la fenêtre reçoit le focus (lecteurs d'écran) sans ouvrir le clavier du téléphone
    card.tabIndex=-1;try{card.focus({preventScroll:true});}catch(e){}
  }

  if(D.readyState==='complete')setTimeout(arm,0);else addEventListener('load',arm);
  W.bgcomNewsPop={open:open};
})();
